import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const InputGroup = props => {
  const {
    name,
    placeholder,
    value,
    dataId,
    className,
    error,
    type,
    onChange
  } = props;
  return (
    <div className="input-group mb-3">
      <input
        type={type}
        className={classnames(`${className} form-control`, {
          "is-invalid": error
        })}
        placeholder={placeholder}
        name={name}
        value={value}
        data-id={dataId}
        onChange={onChange}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

InputGroup.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

InputGroup.defaultProps = {
  type: "text"
};

export default InputGroup;
